module.exports = __webpack_public_path__ + "img/app-1-dark.63e24c67.png";